import React from 'react';
import { Card, Row, Col, Statistic, Spin } from 'antd';
import { UserOutlined, FileTextOutlined, DatabaseOutlined, ClockCircleOutlined, AlertOutlined } from '@ant-design/icons';

const Dashboard = ({ data, loading }) => {
  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: '50px 0' }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div>
      <h2>系统仪表盘</h2>
      <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
        <Col span={6}>
          <Card>
            <Statistic
              title="总用户数"
              value={data?.total_users || 0}
              prefix={<UserOutlined />}
              suffix="人"
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="总项目数"
              value={data?.total_projects || 0}
              prefix={<FileTextOutlined />}
              suffix="个"
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="总资产数"
              value={data?.total_assets || 0}
              prefix={<DatabaseOutlined />}
              suffix="个"
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="待审核用户"
              value={data?.pending_users || 0}
              prefix={<AlertOutlined />}
              suffix="人"
              valueStyle={{ color: '#faad14' }}
            />
          </Card>
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col span={6}>
          <Card>
            <Statistic
              title="待审核订单"
              value={data?.pending_orders || 0}
              prefix={<ClockCircleOutlined />}
              suffix="个"
              valueStyle={{ color: '#fa8c16' }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;